import { useRouter } from 'next/router';
import {
    MobileAlertPanelWrapper,
    SaveEditSearchButton
} from './AlertPanelMobile.styles';
import React, { FC, useContext, MouseEvent } from 'react';
import { SearchContext } from '../SearchContext';
import triggerTracking from '@blueprint/tracking';
import { alertLinkClickHandler } from '../common/alertLinkClickHandler';
import { Links } from '../SearchContext';
import { Icon, Text } from '@blueprint/ui';
import { useIsLoggedIn } from 'shared/hooks/useIsLoggedIn';

type AlertPanelMobileProps = {
    links: Links;
};

export const AlertPanelMobile: FC<AlertPanelMobileProps> = ({ links }) => {
    const { state } = useContext(SearchContext);
    const router = useRouter();
    const isLoggedIn = useIsLoggedIn();

    const { userAlertId, savedSearchAndAlerts } = state;

    const onClick = (
        evt: MouseEvent<HTMLAnchorElement>,
        label?: string,
        requiresAuth = false
    ) => {
        evt.preventDefault();

        if (label) {
            triggerTracking({
                event: 'GAEvent',
                eventCategory: 'search results',
                eventAction: 'click',
                eventLabel: label
            });
        }

        alertLinkClickHandler({
            evt,
            router,
            requiresAuth,
            loggedIn: !!isLoggedIn
        });
    };

    const isSavedSearch = userAlertId !== null;

    return (
        <>
            {isSavedSearch ? (
                <MobileAlertPanelWrapper justifyContent="left">
                    <SaveEditSearchButton
                        variant="tertiary"
                        data-testid="edit-search"
                        href={savedSearchAndAlerts?.uri as string}
                        data-url={savedSearchAndAlerts?.uri as string}
                        onClick={(evt) => onClick(evt, 'edit_search', true)}
                    >
                        <Icon iconId="pencil" />{' '}
                        <Text size="secondary">Edit Search</Text>
                    </SaveEditSearchButton>
                </MobileAlertPanelWrapper>
            ) : (
                <MobileAlertPanelWrapper justifyContent="left">
                    <SaveEditSearchButton
                        variant="tertiary"
                        data-testid="save-search"
                        href={links?.saveSearch || ''}
                        data-url={links?.saveSearch || ''}
                        onClick={(evt) => onClick(evt, 'search_started', true)}
                    >
                        <Icon iconId="save_outline" />{' '}
                        <Text size="secondary">Save search for later</Text>
                    </SaveEditSearchButton>
                </MobileAlertPanelWrapper>
            )}
        </>
    );
};
